module.exports = __webpack_public_path__ + "static/img/audioBg.5c5acfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/audioBg.png
// module id = nIhd
// module chunks = 96